const browserList = { Edge: 113, Chrome: 109, Firefox: 100 };

export default browserList;
